"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider } from "@/integrations/forms/FormProvider";
export default function AdditionalCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [formData, setFormData] = useState({
    name: "",
    organization: "",
    email: "",
    phone: "",
    services: ""
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <section id="additional-cta" className="dark bg-dark-background text-foreground-dark py-24 px-4" ref={ref}>
      <div className={`max-w-2xl mx-auto transition-all duration-150 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-semibold mb-4">
            Ready to Streamline Your Operations?
          </h2>
          <p className="text-lg text-foreground-dark/80 max-w-xl mx-auto">
            Let us handle your administrative tasks so you can focus on
            providing quality care. Request a consultation today.
          </p>
        </div>

        <FormProvider>
          <form onSubmit={handleSubmit} className="space-y-6 bg-dark-background/60 backdrop-blur-sm border border-white/10 rounded-lg p-8 shadow-medium">
            <div>
              <label htmlFor="name" className="block text-sm font-medium mb-2 text-foreground-dark">
                Name *
              </label>
              <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-md text-foreground-dark placeholder:text-foreground-dark/40 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-120" placeholder="Your full name" />
            </div>

            <div>
              <label htmlFor="organization" className="block text-sm font-medium mb-2 text-foreground-dark">
                Organization Name *
              </label>
              <input type="text" id="organization" name="organization" required value={formData.organization} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-md text-foreground-dark placeholder:text-foreground-dark/40 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-120" placeholder="Your organization or practice name" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium mb-2 text-foreground-dark">
                  Email *
                </label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-md text-foreground-dark placeholder:text-foreground-dark/40 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-120" placeholder="your@email.com" />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium mb-2 text-foreground-dark">
                  Phone *
                </label>
                <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-md text-foreground-dark placeholder:text-foreground-dark/40 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-120" placeholder="(555) 000-0000" />
              </div>
            </div>

            <div>
              <label htmlFor="services" className="block text-sm font-medium mb-2 text-foreground-dark">
                Services Requested *
              </label>
              <textarea id="services" name="services" required rows={4} value={formData.services} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-md text-foreground-dark placeholder:text-foreground-dark/40 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-120 resize-none" placeholder="Please describe the administrative services you need..." />
            </div>

            <div className="pt-4">
              <Button type="submit" className="w-full bg-primary hover:bg-primary-hover text-foreground-primary font-semibold py-3 px-6 rounded-md transition-all duration-80 hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 focus:outline-none focus:ring-2 focus:ring-primary">
                Request Consultation
              </Button>
            </div>

            <p className="text-sm text-foreground-dark/60 text-center mt-4">
              We'll respond within 1-2 business days. All information is kept
              confidential in accordance with HIPAA guidelines.
            </p>
          </form>
        </FormProvider>
      </div>
    </section>;
}